import { VodafoneTariffState } from '@tymbe/schema/enums';
import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const paymentPendingVodafoneTariffQueryId = 'admin/vodafoneTariff/paymentPending';

export const PaymentPendingTab = () => {
  return (
    <VodafoneTariffTable
      queryId={paymentPendingVodafoneTariffQueryId}
      state={VodafoneTariffState.PAYMENT_PENDING}
      tabName="payment-pending"
    />
  );
};